import React from 'react';
import { resumeTrainer, addSnoozeTimer, setInfinitySnooze } from '../../store/actions/trainer';
import InactiveTrainer from '../../components/InactiveTrainer/InactiveTrainer';
import { doLogout } from '../../store/actions/user';
import useLocalization from '../../localization/useLocalization';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { isAuthWithPasswordEnabled } from '../../store/selectors/auth';
import type { RootState } from '../../store/types';

function InactiveTrainerContainer() {
    const dispatch = useAppDispatch();
    const localization = useLocalization();
    const stateProps = useAppSelector((store: RootState) => ({
        snoozeTimer: Number(store.trainer.snoozeTimer) || 0,
        errorCode: store.trainer.errorCode,
        authWithPassword: isAuthWithPasswordEnabled(store)
    }));

    return (
        <InactiveTrainer
            {...stateProps}
            localization={localization}
            resumeTrainer={() => dispatch(resumeTrainer())}
            addSnoozeTimer={(value: number) => dispatch(addSnoozeTimer(value))}
            setInfinitySnooze={() => dispatch(setInfinitySnooze())}
            doLogout={() => dispatch(doLogout())}
        />
    );
}

export default InactiveTrainerContainer;
